export const PRICING_ROUTING = [
    {
        path: '/pricing',
        name: 'pricing',
        meta: {
            auth: true,
            breadcrumb: [
                { name: 'Bảng giá', pathName: 'pricing', icon: 'fa fa-table' },
            ]
        },
        component: () => import('./Pricing.vue'),
        redirect: { name: 'pricing-index' },
        children: [
            { 
                path: '/bang-gia.html',
                name: 'pricing-index',
                component: () => import('./components/main-pricing/MainPricing.vue')
            }
        ]
    }
];